module.exports = __webpack_public_path__ + "static/img/yq.d3c525b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yq.png
// module id = mjMz
// module chunks = 1